<label *ngIf="componentId" for="{{ componentId }}" class="label-basic__text {{ styleClass }} {{ inputClass }}">
  <ng-container *ngTemplateOutlet="contentBlock"></ng-container>
</label>
<label *ngIf="!componentId" class="label-basic__text {{ styleClass }}">
  <ng-container *ngTemplateOutlet="contentBlock"></ng-container>
</label>

<ng-template #contentBlock>
  <div *ngIf="displayText" class="label-basic__content" [innerHTML]="displayText"></div>
  <ng-content></ng-content>
</ng-template>
